import { GetUserClaimsType } from "../../types/Claim";
import { GetUserRolesType } from "../../types/Role";
import { get } from "../../utils/axios-config";
import { GET_USER_ROLES } from "../../utils/constants";

export const getUserRoles = async (userId: string) => await get<GetUserRolesType[]>(`${GET_USER_ROLES}?UserId=${userId}`);
